import React, {useState} from 'react';
import {useTranslate} from "../../../system/useTranslate";
import {useUpdateEffect} from "primereact/hooks";
import {InputText} from "primereact/inputtext";
import Icon from "../../../system/components/icon";
import TaskToolbar from "./task-toolbar";

function AddSubTask({onChange, onDelete, payload, onSave, onClick}) {
    const [subTaskData, setSubTaskData] = useState(payload?.subTaskData);
    const translate = useTranslate();
    useUpdateEffect(()=>{
        onChange?.({...subTaskData})
    },[subTaskData])

    return(
        <div className="flex flex-column w-full">
            <div className="flex align-items-end gap-2">
                <InputText readOnly={subTaskData?.documentId} value={subTaskData?.title||""} onChange={(e)=>{setSubTaskData({...subTaskData, title:e.target.value})}} className={`text-xs flex-1 border-none shadow-none ${subTaskData?.documentId&&"cursor-pointer"}`} onClick={()=>{subTaskData?.documentId&&onClick?.(subTaskData)}} placeholder={translate("subtask-title-placeholder")}/>
                <TaskToolbar miniToolbar taskType={false} project={false} setTaskData={setSubTaskData} taskData={subTaskData} />
                {onSave&&(<Icon onClick={()=>{onSave?.(subTaskData)}} icon="mi mi:save" className="border-1 border-300 border-dashed border-round-2xl p-2 text-lg h-fit"/>)}
                {!subTaskData?.documentId&&<Icon onClick={()=>{onDelete?.()}} icon="mi mi:delete" className="border-1 border-300 border-dashed border-round-2xl p-2 text-lg h-fit"/>}
            </div>
        </div>
    )
}
export default AddSubTask;